// eslint-disable-next-line no-console
export default () => console.log('example');
